import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useReduxState } from "src/hooks/useRedux";
import { useStaticSelect } from "src/hooks/form/useSelect";

const useCountry = <T>(props: useFieldProps<T>) => {
  const field = useStaticSelect<typeof countries, T>(props);
  const countries = useReduxState(["inquiryReducer", "masterData", "countriesList"])
    .value;

  React.useEffect(() => {
    field.setValue("");
    field.setOptionsData(countries, (data) => {
      return data?.map((el) => ({ key: el.countryCode, label: el.countryName }));
    });
  }, [countries]);

  return field;
};

export default useCountry;
